"use strict";

var Component = require('./Component');

var ComponentCollection = require('./ComponentCollection');

var Envelope = require('./Envelope');

var PaperComponent = require('./PaperComponent');

var LargePaperComponent = require('./LargePaperComponent');

var LetterpressComponent = require('./LetterpressComponent');

var Product = require('./Product');

var PaperProduct = require('./PaperProduct');

var SampleProduct = require('./SampleProduct');

var SamplePaperProduct = require('./SamplePaperProduct');

var SampleComponent = require('./SampleComponent');

module.exports = {
  Component: Component,
  ComponentCollection: ComponentCollection,
  Envelope: Envelope,
  PaperComponent: PaperComponent,
  LargePaperComponent: LargePaperComponent,
  LetterpressComponent: LetterpressComponent,
  Product: Product,
  PaperProduct: PaperProduct,
  SampleProduct: SampleProduct,
  SamplePaperProduct: SamplePaperProduct,
  SampleComponent: SampleComponent
};